var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-page"},[_c('RichTextPopup',{attrs:{"isActive":_vm.introActive,"content":_vm.post.content.rendered,"blocks":_vm.contentBlocks},on:{"close-popup":_vm.back,"button-click":_vm.activateEmbed}}),(_vm.embedActive)?_c('Embed',{attrs:{"src":_vm.post.acf.embed_link,"active":_vm.embedActive}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }